import axios from 'axios';

const tolinkUrl = 'http://tolink.lvshuimeng.com' // 绿水梦采集云域名

export function tolink_Info(token) {
  return axios({
    method: "get",
    baseURL: tolinkUrl,
    url: "/go/auth/info",
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Authorization': token,
    },
  })
}

export function tolink_Stream(token) {
  return axios({
    method: "post",
    baseURL: tolinkUrl,
    url: "/go/stream/findpage",
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Authorization': token,
    },
    params: { Pagenum: 1, Pagesize: 10000, Orderobject: "name", Ordervalue: 1, "Function": "intact" },
  })
}

export function tolink_Label(apiKey) {
  return axios({
    method: "post",
    baseURL: tolinkUrl,
    url: "/go/api/getlabel",
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    params: { Apikey: apiKey },
  })
}

export function tolink_Realtime(apiKey, list) {
  return axios({
    method: "post",
    baseURL: tolinkUrl,
    url: "/go/api/getdata",
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    params: { Apikey: apiKey, "Function": "realtime" },
    data: JSON.stringify(list),
  })
}

export function tolink_Mqttwrite(apiKey, labelID, value) {
  return axios({
    method: "post",
    baseURL: tolinkUrl,
    url: "/go/api/command",
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    params: { Apikey: apiKey, "Function": "mqtt_write" },
    data: JSON.stringify({ data: labelID, value }),
  })
}